import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import intervalPlural from 'i18next-intervalplural-postprocessor';

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
	en: {
		translation: {
			"footer contacts": "Contact us",

			"inner page copyright": "© 1997—{{dateEnd}} PJSC Sberbank.",

			"main h1": "Experience.<br />Design.<br />Platform.",
			"main description": "Welcome to the Triplex Design System.<br />This is where your ideas will<br />take shape.",
			"main copyright": "© 1997—{{dateEnd}} PJSC Sberbank.<br />General license for banking operations<br />dated August 11, 2015. Registration number - 1481.",

			"menu to home": "Home",

			"page not found": "Page not found",
			"page not found link": "Home",

			"section not translated": "This page has not been translated yet",
			"section not translated link": "Back",

			"search not found": "Nothing found. <br />Try editing your query.",
			"search placeholder": "Search",
			"search result item nodes count pre": "And",
			"search result item nodes count": "(1)[more match];(2-inf)[more matches];",
			"search result item nodes count post": "on the page.",
			"search two characters": "Type in at least two characters",
		}
	},
	ru: {
		translation: {
			"footer contacts": "Написать нам",

			"inner page copyright": "© 1997—{{dateEnd}} ПАО Сбербанк.",

			"main h1": "Опыт.<br />Дизайн.<br />Платформа.",
			"main description": "Добро пожаловать<br />в Дизайн-систему Триплекс.<br />Здесь твои идеи<br />обретут форму.",
			"main copyright": "© 1997—{{dateEnd}} ПАО Сбербанк.<br />Генеральная лицензия на осуществление банковских операций<br />от 11 августа 2015 года. Регистрационный номер — 1481.",

			"menu to home": "Главная",

			"page not found": "Такой страницы не существует",
			"page not found link": "На главную",

			"section not translated": "Эта страница в процессе перевода",
			"section not translated link": "Назад",

			"search not found": "Ничего не найдено.<br />Попробуйте изменить запрос.",
			"search placeholder": "Что вы ищете?",
			"search result item nodes count pre": "И еще",
			"search result item nodes count": "(0)[совпадений];(1)[совпадение];(2-4)[совпадения];(5-inf)[совпадений];",
			"search result item nodes count post": "на странице.",
			"search two characters": "Введите более двух символов",
		}
	},
	zh: {
		translation: {
			"footer contacts": "写信给我们",
			"inner page copyright": "© 1997—{{dateEnd}} 俄罗斯联邦储蓄银行。",
			"main h1": "经验。<br />设计。<br />平台。",
			"main description": "欢迎来到三重设计系统。<br />在这里，你的想法<br />将会变成现实。",
			"main copyright": "© 1997—{{dateEnd}} 俄罗斯联邦储蓄银行（ПАО Сбербанк）。<br />银行业务的总许可证<br />自2015年8月11日起。注册号 — 1481。",
			"menu to home": "主页",
			"page not found": "该页面不存在。",
			"page not found link": "返回首页",
			"section not translated": "此页面正在翻译中。",
			"section not translated link": "返回",
			"search not found": "未找到任何内容。<br />请尝试更改查询。",
			"search placeholder": "你在寻找什么？",
			"search result item nodes count pre": "还有其他的。",
			"search result item nodes count": "(0)[没有匹配];(1)[一个匹配];(2-4)[多个匹配];(5-inf)[许多匹配];",
			"search result item nodes count post": "在页面上。",
			"search two characters": "请输入两个以上的字符。"
		}
	},
	zoomer: {
		translation: {
			"footer contacts": "Написать нам",
			"inner page copyright": "© 1997—{{dateEnd}} ПАО Сбербанк.",
			"main h1": "Вайбовый экспириенс 🤔 <br />Дизайн 🎨 чтобы выглядеть на все 100! 😎👌  <br />Платформа 🚀 ",
			"main description": "Йо, чуваки! 👋✨ Добро пожаловать в нашу Дизайн-систему Триплекс!<br /> 🎨💥 Тут ваши идеи не просто валяются, а превращаются в шедевры! 💅🔥<br /> Давайте, зажгём! 💖🚀",
			"main copyright": "© 1997—{{dateEnd}} ПАО Сбербанк.<br />Генеральная лицензия на осуществление банковских операций<br />от 11 августа 2015 года. Регистрационный номер — 1481.",
			"menu to home": "Главняк, чуваки! 😎🔥",
			"page not found": "Эй, чё за бред? 🤔 Эта страница как призрак, её нет! 👻💔 Где она, я не понял? 😂",
			"page not found link": "На главняк, чуваки! 🚀💥 Давайте зашибись! 😎✨",
			"section not translated": "Эта страница в процессе перевода, типа, chill 🤙😜✨",
			"section not translated link": "Назад, как будто я на старом компе, где кнопка \"Назад\" застряла 😂💻✨!",
			"search not found": "Ничего не нашлось, братан 😅💔. Попробуй переформулировать свой запрос, может, повезёт! 🤷‍♂️✨",
			"search placeholder": "Чё ищешь, бро? 🤔💁‍♂️ Может, мемы или чё-то по кайфу? 😂✨",
			"search result item nodes count pre": "И еще, братан, 😂💁‍♂️! Че за движ? Давай, зажигай! 🔥✨",
			"search result item nodes count": "(0) ноль совпадений, типа, вообще ноль 😅; (1) одно совпадение, как будто нашёл единорога 🦄; (2-4) парочка совпадений, как будто на вечеринке, где все знакомы 🎉; (5-inf) много совпадений, как будто в TikTok, где все твои френды 😂✨!",
			"search result item nodes count post": "На страничке, чё как? 😜📱✨",
			"search two characters": "Эй, чё за фигня? 😅 Вводи больше двух символов, а то как будто в чатике с ботом застрял! 😂✌️"
		}
	}
};

i18n
	.use(intervalPlural)
	.use(initReactI18next) // passes i18n down to react-i18next
	.init({
		resources,
        lng: "ru", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
		// you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
		// if you're using a language detector, do not define the lng option

		interpolation: {
			escapeValue: false // react already safes from xss
        }
	});

export default i18n;
